import { CommonModule } from '@angular/common';
import { ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'Angular/config/config.module';
import { IconWrapperModule } from 'Angular/features/components/icon-wrapper/icon-wrapper.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { KeyStatsModalModule } from 'CalculationsApp/ts/features/key-stats-modal/key-stats-modal.module';
import { GeneralChartModule } from 'ChartApp/ts/features/general-chart/general-chart.module';
import { PieChartModule } from 'ChartApp/ts/features/pie-chart/pie-chart.module';
import { SingleSeriesFundChartModule } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.module';
import { ComparablesModalButtonModule } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.module';
import { PerformanceIncludeBenchmarkCheckboxModule } from 'SecuritiesApp/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox.module';
import { RiskInfoCheckboxesModule } from 'SecuritiesApp/ts/features/risk-info-checkboxes/risk-info-checkboxes.module';
import { RiskInfoScatterPlotModule } from 'SecuritiesApp/ts/features/risk-info-scatter-plot/risk-info-scatter-plot.module';
import { RiskLookbackModule } from 'SecuritiesApp/ts/features/risk-lookback/risk-lookback.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { TopPortfolioHoldingsModule } from 'SecuritiesApp/ts/features/top-portfolio-holdings/top-portfolio-holdings.module';
import { IconWrapperComponent } from 'Angular/features/components/icon-wrapper/icon-wrapper.component';
import { HelpModalWithTriggerComponent } from 'Angular/features/components/modals/help-modal/components/help-modal-with-trigger.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { KeyStatsModalComponent } from 'CalculationsApp/ts/features/key-stats-modal/components/key-stats-modal/key-stats-modal.component';
import { GeneralChartComponent } from 'ChartApp/ts/features/general-chart/components/general-chart/general-chart.component';
import { GeneralChartResponsiveComponent } from 'ChartApp/ts/features/general-chart/components/general-chart-responsive/general-chart-responsive.component';
import { PieChartComponent } from 'ChartApp/ts/features/pie-chart/pie-chart.component';
import { SingleSeriesFundChartComponent } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.component';
import { ComparablesModalButtonComponent } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.component';
import { RiskInfoCheckboxesComponent } from 'SecuritiesApp/ts/features/risk-info-checkboxes/risk-info-checkboxes.component';
import { RiskInfoScatterPlotComponent } from 'SecuritiesApp/ts/features/risk-info-scatter-plot/risk-info-scatter-plot.component';
import { RiskLookbackComponent } from 'SecuritiesApp/ts/features/risk-lookback/risk-lookback.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { TopPortfolioHoldingsComponent } from 'SecuritiesApp/ts/features/top-portfolio-holdings/top-portfolio-holdings.component';
import { getLogger } from 'Angular/state/logger';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import { PerformanceIncludeBenchmarkCheckboxComponent } from 'SecuritiesApp/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    ComparablesModalButtonComponent,
    GeneralChartResponsiveComponent,
    GeneralChartComponent,
    HelpModalWithTriggerComponent,
    IconWrapperComponent,
    KeyStatsModalComponent,
    PerformanceIncludeBenchmarkCheckboxComponent,
    PieChartComponent,
    SideMenuComponent,
    RiskInfoCheckboxesComponent,
    RiskInfoScatterPlotComponent,
    RiskLookbackComponent,
    SecurityHeaderControlComponent,
    SingleSeriesFundChartComponent,
    TopBarNavComponent,
    TopPortfolioHoldingsComponent,
];
export class MutualFundsQuoteModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [
            ComparablesModalButtonComponent,
            GeneralChartComponent,
            HelpModalWithTriggerComponent,
            IconWrapperComponent,
            PerformanceIncludeBenchmarkCheckboxComponent,
            PieChartComponent,
            RiskInfoCheckboxesComponent,
            RiskInfoScatterPlotComponent,
            RiskLookbackComponent,
            SingleSeriesFundChartComponent,
            TopPortfolioHoldingsComponent,
        ];
    }
}
MutualFundsQuoteModule.ɵfac = function MutualFundsQuoteModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsQuoteModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
MutualFundsQuoteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsQuoteModule });
MutualFundsQuoteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ComparablesModalButtonModule,
        FormsModule,
        ConfigModule,
        CommonModule,
        ComparablesModalButtonModule,
        GeneralChartModule,
        IconModule,
        IconWrapperModule,
        KeyStatsModalModule,
        NavigationModule,
        PerformanceIncludeBenchmarkCheckboxModule,
        PieChartModule,
        RiskInfoCheckboxesModule,
        RiskInfoScatterPlotModule,
        RiskLookbackModule,
        SecurityHeaderControlModule,
        SingleSeriesFundChartModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        TopPortfolioHoldingsModule] });
